import React, { useState } from 'react';
import {
  Grid,
  Checkbox,
  IconButton,
  Typography,
  Button,
  CircularProgress,
  LinearProgress
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { useParams } from 'react-router-dom';
import { editReportStyles } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { removeUserFromReportAction } from '../../redux/actions/reports-actions';
import store from '../../../../../core/redux/store';
import LoadingSpinner from '../loading-spinner';

export default function UserList() {
  const classes = editReportStyles();
  // @ts-ignore
  const { id } = useParams();
  const dispatch = useDispatch();

  const state = store.getState();
  const token = state.token.token;

  const { report, removing } = useSelector((state) => state.reports);
  const { users, loading } = useSelector((state) => state.users);

  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);

  const handleSelect = (id: string) => {
    setSelectedUsers((prev) =>
      prev.includes(id) ? prev.filter((userId) => userId !== id) : [...prev, id]
    );
  };

  const handleBulkDelete = () => {
    const permission_ids = [];

    selectedUsers.forEach((userId) => {
      const user = users.find((user) => user.id === userId);
      if (user) {
        // @ts-ignore
        permission_ids.push(user.permissions.permissions_id);
      }
    });

    dispatch(removeUserFromReportAction(token, report, permission_ids, selectedUsers));
  };

  const visibleUsers = (users) => {
    return users.filter((user) => user.permissions?.reports.some((report) => report.id === id));
  };

  const submitRemoveUser = async (user_id: string) => {
    const user = users.find((user) => user.id === user_id);

    if (user) {
      dispatch(
        removeUserFromReportAction(token, report, [user.permissions.permissions_id], [user_id])
      );
    }
  };

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <Typography className={classes.addUsersHeading}>Current Users</Typography>
        {loading && <LinearProgress />}
      </Grid>
      <Grid container className={classes.currentUsersContainer}>
        {visibleUsers(users).map((user) => {
          const name = `${user.firstname} ${user.lastname}`;
          return (
            <Grid
              container
              alignItems="center"
              xs={12}
              direction="row"
              key={user.id}
              spacing={2}
              className={classes.userRow}
              onClick={() => handleSelect(user.id)}
            >
              <Grid item>
                <Checkbox
                  checked={selectedUsers.includes(user.id)}
                  onChange={() => handleSelect(user.id)}
                />
              </Grid>
              <Grid item xs>
                <Typography>{name}</Typography>
              </Grid>
              <Grid item>
                <IconButton onClick={() => submitRemoveUser(user.id)} color="secondary">
                  {removing.length === 1 && user.id == removing[0] ? (
                    <LoadingSpinner />
                  ) : (
                    <DeleteIcon />
                  )}
                </IconButton>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
      <Grid container justify="flex-end">
        <Button
          variant="contained"
          color="secondary"
          onClick={handleBulkDelete}
          disabled={selectedUsers.length === 0 || removing.length > 0}
        >
          {removing.length > 1 && <LoadingSpinner />}
          Delete Selected
        </Button>
      </Grid>
    </Grid>
  );
}
